import { getBase64 } from "./ImageToBase64"


export function getImage(id){
    const images = [
        {
            doc_id:  3,
            image: require("../../image/3.png") 
        },
        {
            doc_id:  8,
            image: require("../../image/8.png") 
        },
        {
           doc_id:  23,
           image: require("../../image/23.png") 
        },
        {
            doc_id:  34,
            image: require("../../image/34.png") 
        },
        {
            doc_id:  40,
            image: require("../../image/40.png") 
        },
        {
            doc_id:  41,
            image: require("../../image/41.png") 
        },
        {
            doc_id:  42,
            image: require("../../image/42.png") 
        },
        {
            doc_id:  44,
            image: require("../../image/44.png") 
        },
        {
            doc_id:  45,
            image: require("../../image/45.png") 
        },
        {
            doc_id:  46,
            image: require("../../image/46.png") 
        },
        {
            doc_id:  47,
            image: require("../../image/47.png") 
        },
        {
            doc_id:  48,
            image: require("../../image/48.png") 
        },
        {
            doc_id:  49,
            image: require("../../image/49.png") 
        },
        {
            doc_id:  50,
            image: require("../../image/50.png") 
        },
        {
            doc_id:  51,
            image: require("../../image/51.png") 
        },
        {
            doc_id:  52,
            image: require("../../image/52.png") 
        },
        {
            doc_id:  53,
            image: require("../../image/53.png") 
        },
        {
            doc_id:  54,
            image: require("../../image/54.png") 
        },
        {
            doc_id:  55,
            image: require("../../image/55.png") 
        },
        {
            doc_id:  56,
            image: require("./../../image/56.png") 
        },
        {
            doc_id:  57,
            image: require("../../image/57.png") 
        },
        {
            doc_id:  58,
            image: require("../../image/58.png") 
        },
        {
            doc_id:  59,
            image: require("../../image/signature.png") 
        }
    ]

    const image = images.find(image => image.doc_id === id)
    // console.log(image);

    return getBase64(image ? image.image : "");
    // const img="data:image/gif;base64,R0lGODlhAQABAIAAAP7//wAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==";
    // return img;
}

